import commonValidate from '../../../common-validate.js';
import commonUtil from '../../../commonutil.js';
import constants from '../../../constants.js';
import server from "../../../ServerApi.js";

export default {
    getLocaledText(i18n, messageMap) {
        switch(i18n.locale) {
            case 'ja':
                return messageMap.ja;
            default:
                return messageMap.en;
        }
    },
    needSelection(item) {
        if ('candidates' in item) {
            return true;
//            return item.candidates.length > 0;
        }
        return false;
    },
    judgeVisible(item) {
        if ('hidden' in item) {
            return this.isBooleanFalse(item.hidden);
        }
        return true;
    },
    judgeDisabled(item) {
        if ('disabled' in item) {
            return !this.isBooleanFalse(item.disabled);
        }
        return false;
    },
    judgeHelpItem(i18n, template) {
        if (template.helpHtml == null) {
            return false;
        }
        if (template.helpHtml[i18n.locale]  == null) {
            return false;
        } else {
            return true;
        }
    },
    getPlaceHolder(i18n, item) {
        if (this.judgeDisabled(item)) {
            return item.value;
        }
        if ('placeholder' in item) {
            switch(i18n.locale) {
                case 'ja':
                    return item.placeholder.ja;
                default:
                    return item.placeholder.en;
            }
        }
        if (i18n.locale == 'ja') {
            return i18n.messages.ja.message["place_holder_input_text"];
        } else {
            return i18n.messages.en.message["place_holder_input_text"];
        }
    },
    getType(item) {
        if ('type' in item) {
            return item.type;
        }
        return 'text';
    },
    getSelectedValue(item) {
        return item.candidates[item.value].value;
    },
    getNameOfSelectedValue(i18n, item) {
        if (i18n.locale === 'ja') {
            return item.candidates[item.value].name.ja;
        } else {
            return item.candidates[item.value].name.en;
        }
    },
    getValidationRule(item) {
        if ("invalid" in item) {
            if (!this.isBooleanFalse(item.invalid)) {
                return "invalid"
            }
        }
        if (this.needSelection(item)) {
            return "selectItem";
        }
        if ('validationRule' in item) {
            return item.validationRule;
        }
        return 'none';
    },
    getHelpHtmlUrl(i18n, helpHtml) {
        if (helpHtml == null) { return null}
        return "../manual/" + i18n.locale +"/" + helpHtml[i18n.locale];
    },
    isBooleanFalse(item) {
        if (typeof(item) == 'boolean') {
            return !item;
        }
        return false;
    },
    shownContentsExist(processor) {
        if ('candidates' in processor) {
            return true;
        }
        for (let parameter of processor.parameters) {
            if (!('hidden' in parameter)) {
                return true;
            }
            if (this.isBooleanFalse(parameter.hidden)) {
                return true;
            }
        }
        return false;
    },
    getDefaultIconUrl() {
        return 'https://staging-map-icon.s3-ap-northeast-1.amazonaws.com/icon/mark_sai.svg';
    },
    findCommand(parameter, command) {
        if (command in parameter) {
            let falseDetected = this.isBooleanFalse(parameter[command]);
            return !falseDetected;
        }
        return false;
    },
    needStt(item) {
        if ('needStt' in item) {
            if (item.needStt == null) {
                return false;
            }
            return !this.isBooleanFalse(item.needStt);
        }
        return false;
    },
    getDisplayNameValidator() {
        return {
            validationRule: 'reqDisplayName',
            isComposing: false,
            valid: false,
            message: '',
        };
    },
    getParameterValidator(parameter) {
        if (!this.judgeVisible(parameter)) {
            return;
        }

        let validationRule = this.getValidationRule(parameter);
        if (validationRule === 'none') {
            return;
        }

        return  {
            validationRule: validationRule,
            isComposing: false,
            valid: false,
            message: '',
        }
    },
    addValidatorToProcessor(processor) {
        for (let parameter of processor.parameters) {
            if (!this.judgeVisible(parameter)) {
                continue;
            }
            let validationRule = this.getValidationRule(parameter);
            if (validationRule === 'none') {
                continue;
            }
            parameter.validator = {
                validationRule: validationRule,
                isComposing: false,
                valid: false,
                message: '',
            };
        }
    },
    addValidators(templateOrDefinition) {
        let displayNameValidator = {
            validationRule: 'reqDisplayName',
            isComposing: false,
            valid: false,
            message: '',
        };
        templateOrDefinition.displayNameValidator = displayNameValidator;

        for (let processor of templateOrDefinition.processors) {
            for (let parameter of processor.parameters) {
                if (!this.judgeVisible(parameter)) {
                    continue;
                }
                let validationRule = this.getValidationRule(parameter);
                if (validationRule == 'none') {
                    continue;
                }
                let validator = {
                    validationRule: validationRule,
                    isComposing: false,
                    valid: false,
                    message: '',
                };
                parameter.validator = validator;
            }
        }
    },
    validateProcessor(i18n, processor) {
        for (let parameter of processor.parameters) {
            if (!('validator' in parameter)) {
                continue;
            }
            this.validateItem(i18n, parameter.validator, parameter.value);
        }
    },
    validateAll(i18n, templateOrDefinition) {
        this.validateItem(i18n, templateOrDefinition.displayNameValidator, templateOrDefinition.displayName);

        for (let processor of templateOrDefinition['processors']) {
            for (let parameter of processor.parameters) {
                if (!('validator' in parameter)) {
                    continue;
                }
                this.validateItem(i18n, parameter.validator, parameter.value);
            }
        }
    },
    validateItem(i18n, validator, value) {
        if (validator == null) {
            return;
        }

        if (validator.isComposing) {
            // inputting with IME
            return;
        }

        let validateResult = commonValidate.validateItem(i18n, validator.validationRule, value);
        validator.valid = validateResult.valid;
        validator.message = validateResult.valid ? '' : validateResult.message;
    },
    judgeInvalidParameterRemains(templateOrDefinition) {
        if (!templateOrDefinition.displayNameValidator.valid) {
            return true;
        }
        for (let processor of templateOrDefinition.sections) {
            for (let parameter of processor.parameters) {
                if (!('validator' in parameter) || parameter.validator == null) {
                    continue;
                }
                if (!parameter.validator.valid) {
                    return true;
                }
            }
        }
        return false;
    },
    overwriteValidationResultToRef(refTarget, validator) {
        if (validator.valid) {
            refTarget.validateState = '';
            refTarget.clearValidate();
        } else {
            refTarget.validateState = 'error';
            refTarget.validateMessage = validator.message;
        }
    },
    getProcessorDefinitionFromListById(processorDefinitionList, targetId) {
        for (let processorDefinition of processorDefinitionList) {
            if (processorDefinition.id == targetId) {
                return processorDefinition;
            }
        }
        return null;
    },
    createStorageCandidateArray(i18n, processorDefinitionList, alreadySelectedStorage) {
        let storageCandidates = [];
        let selectedStorageIndex = 0;
        storageCandidates.push({
            name: commonUtil.getMessageText(i18n,"item_default"),
            value: 0,
        });
        let index = 0;
        for (let processorDefinition of processorDefinitionList) {
            if (processorDefinition.serviceId != constants.VAULT_SERVICE_STORAGE) {
                continue;
            }
            index++; // starts from 1
            let candidate = {
                name: processorDefinition.displayName,
                value: processorDefinition.id,
            };
            storageCandidates.push(candidate);
            if ((alreadySelectedStorage != null) && (processorDefinition.id == alreadySelectedStorage.id)) {
                selectedStorageIndex = index;
            }
        }
        return {storageCandidates: storageCandidates, selectedStorageIndex: selectedStorageIndex};
    },
    getWritePermissionCheckParam(sections) {
        for (let section of templateOrDefinition.sections) {
            let processorResult = this.getWritePermissionCheckParamEachProcessor(section);
            if (processorResult != null) {
                return processorResult;
            }
        }
        return null;
    },
    getWritePermissionCheckParamEachProcessor(section) {
        var notFound = true;
        var keyVaultId = null;
        var folderId = null;
        var filePathTemplate = null;
        for (let parameter of section.parameters) {
            if (parameter.jsonKey == 'keyVaultId') {
                keyVaultId = this.getSelectedValue(parameter);
                notFound = false;
            } else if (this.findCommand(parameter, 'selectStorageFolder')) {
                folderId = parameter.value;
                notFound = false;
            } else if (parameter.jsonKey == 'filePathTemplate') {
                filePathTemplate = parameter.value;
                notFound = false;
            }
        }
        if (notFound) {
            return null;
        }

        // key vault is not found, so impossible to carry out permission check
        if (keyVaultId == null) {
            return null;
        }
        // root folder, so no need to check write permission
        if ((folderId == null) || (folderId == '')) {
            return null;
        }
        // file path template is customized, so responsible is assumed to be in tenant
        if ((filePathTemplate != null) && (filePathTemplate != '')) {
            return null;
        }
        return {keyVaultId: keyVaultId, folderId: folderId};
    },
    async requestStorageFolderNameIfRequired(keyVaultId, folderId) {
        // no need to request folder name
        if ((folderId == null) || (folderId == '')) {
            return '';
        }

        if (keyVaultId == null) {
            return 'invalid key vault';
        }

        try {
            let res = await server.post('/getstoragefoldername', {keyVaultId: keyVaultId, folderId: folderId});
            return (res.data.status == constants.STATUS_SUCCESS) ? res.data.folderName : 'Folder not found';
        } catch (error) {
            commonUtil.putExceptionErrorMessage(this, "requestStorageFolderNameIfRequired", error);
            return 'Folder not found';
        }
    },
};
